import React, { useEffect, useRef, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { getImagenPrivada } from '../services/apis';

const cacheImagenesPrivadas = new Map();
const peticionesImagenesPrivadas = new Map();

const cargarImagenPrivadaCacheada = async (path) => {
    if (cacheImagenesPrivadas.has(path)) {
        return cacheImagenesPrivadas.get(path);
    }

    if (peticionesImagenesPrivadas.has(path)) {
        return peticionesImagenesPrivadas.get(path);
    }

    const peticion = getImagenPrivada(path).then((blob) => {
        if (!blob) {
            peticionesImagenesPrivadas.delete(path);
            return null;
        }

        const objectUrl = URL.createObjectURL(blob);
        cacheImagenesPrivadas.set(path, objectUrl);
        peticionesImagenesPrivadas.delete(path);
        return objectUrl;
    });

    peticionesImagenesPrivadas.set(path, peticion);
    return peticion;
};

export const ImagenPrivada = ({ path, alt = '', className = '', wrapperClassName = '', ...props }) => {
    const [src, setSrc] = useState('');
    const [visible, setVisible] = useState(false);
    const contenedorRef = useRef(null);

    useEffect(() => {
        if (!path) {
            setSrc('');
            setVisible(false);
            return undefined;
        }

        if (cacheImagenesPrivadas.has(path)) {
            setSrc(cacheImagenesPrivadas.get(path));
            setVisible(true);
            return undefined;
        }

        setSrc('');
        setVisible(false);

        const node = contenedorRef.current;
        if (!node) {
            setVisible(true);
            return undefined;
        }

        if (!('IntersectionObserver' in window)) {
            setVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '500px 0px' }
        );

        observer.observe(node);

        return () => observer.disconnect();
    }, [path]);

    useEffect(() => {
        let active = true;

        const cargarImagen = async () => {
            if (!path || !visible) {
                setSrc('');
                return;
            }

            const objectUrl = await cargarImagenPrivadaCacheada(path);
            if (!active || !objectUrl) {
                return;
            }

            setSrc(objectUrl);
        };

        cargarImagen();

        return () => {
            active = false;
        };
    }, [path, visible]);

    return (
        <span ref={contenedorRef} className={wrapperClassName || 'private-image-holder'}>
            {src ? (
                <img src={src} alt={alt} className={className} {...props} />
            ) : (
                <span className="private-image-loader">
                    <CircularProgress size={26} thickness={4} />
                </span>
            )}
        </span>
    );
};
